import { render, staticRenderFns } from "./NewInvoiceItemWidget.vue?vue&type=template&id=a3417e82"
import script from "./NewInvoiceItemWidget.vue?vue&type=script&lang=js"
export * from "./NewInvoiceItemWidget.vue?vue&type=script&lang=js"
import style0 from "./NewInvoiceItemWidget.vue?vue&type=style&index=0&id=a3417e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports